import { hooks, services } from "../../../studentportal-sdk";
import { useEffect } from "react"

export const UserHook = (props) => {
  // User service instance
  const _userService = services.User(props);
  const _courseService = services.Course(props);
  const _liveSessionService = services.LiveClass(props);
  const _assessmentService = services.Assessment(props);
  const _authService  = services.Authentication(props);

  // authentication service
  const {
    store: { authUser },
    action: { getAllUsers, getAllStudents, getUser },
    history,
  } = _userService;

  const {
    action: { getLiveClass },
  } = _liveSessionService;

  const {
    store: { courseAction },
    action: { getAllCourse, getCourseById },
  } = _courseService;

  const {
    // store: { assessmentAction },
    action: {
      getAllAssessment
    },

  } = _assessmentService;


//eslint disable
  useEffect(() => {
    getLiveClass();
  }, []);

  useEffect(() => {
    getAllUsers();

    getAllCourse();
    getAllAssessment()
  }, []);

  useEffect(() => {
    getAllStudents();
  }, []);

  useEffect(() => {
   authUser && getUser(authUser.id);
  }, []);

  // redirect to login page if user is not signed-in
  // useEffect(() => {
  //   !authUser && props.history.push("/login");
  //   // && utils.toolkit.navigate.push('/login')
  // }, [authUser, props.history]);

  return {
    liveSessionService: {
      ..._liveSessionService,
    },
    userService: {
      ..._userService,
    },
    courseService: {
      ..._courseService,
    },
    authService: {
      ..._authService
    },
    assessmentService: {
      ..._assessmentService,
    },
    ...props,
  };
};

// Wrapper to inject configuration and utilities into the hook
export const UserManagement = (props) =>
  UserHook(hooks.UtilityAndConfig(props));
